import { render, staticRenderFns } from "./q6.vue?vue&type=template&id=40711292&scoped=true"
import script from "./q6.vue?vue&type=script&lang=js"
export * from "./q6.vue?vue&type=script&lang=js"
import style0 from "./q6.vue?vue&type=style&index=0&id=40711292&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40711292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40711292')) {
      api.createRecord('40711292', component.options)
    } else {
      api.reload('40711292', component.options)
    }
    module.hot.accept("./q6.vue?vue&type=template&id=40711292&scoped=true", function () {
      api.rerender('40711292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q6.vue"
export default component.exports